var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusCircleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12.0001C22 17.5229 17.5229 22.0001 12 22.0001C6.47719 22.0001 2.00004 17.5229 2.00004 12.0001C2.00004 6.47722 6.47719 2.00007 12 2.00007C17.5229 2.00007 22 6.47722 22 12.0001ZM6.74967 13.25L5.99967 12.25L6.74967 11.25L17.2497 11.25L17.9997 12.25L17.2497 13.25L6.74967 13.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleFilled);
export default __webpack_public_path__ + "static/media/minus-circle-filled.7c16583ac1793262f56e3a82bb4fde5d.svg";
export { ForwardRef as ReactComponent };